<rcl-modal
	id="currency-conversion-rcl-modal"
	[show]="showCurrencyConvertionProgramModal"
	[mobileFullScreen]="false"
	[attr.aria-hidden]="!showCurrencyConvertionProgramModal"
	(onClose)="closeModal()"
>
	<rcl-modal-content id="currency-conversion-rcl-modal__content" [attr.tabindex]="0">
		<h1 id="currency-conversion-rcl-modal__content-h1" class="rcl-modal-title rcl-h3">
			{{ bundle() && bundle()['modal.header.currency.conversion'] }}
		</h1>
		<p id="currency-conversion-rcl-modal__content-p">
			{{ bundle() && bundle()['modal.content.currency.conversion'] }}
		</p>
	</rcl-modal-content>
	<rcl-modal-actions id="currency-conversion-rcl-modal__actions">
		<button id="currency-conversion-rcl-modal__actions__close" (click)="closeModal()" class="rcl-button-secondary">
			{{ bundle() && bundle()['button.close'] }}
		</button>
	</rcl-modal-actions>
</rcl-modal>
